import React from 'react';

const WhiteBar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1945 46"
    fill="none"
    width="110%"
    height="auto"
    preserveAspectRatio="xMidYMid meet"
  >
    <path d="M0 0.947266H1944.48V45.6725H0V0.947266Z" fill="white" />
  </svg>
);

export default WhiteBar;
